import React, { useEffect, useState } from "react";
import MainLayout from "Screens/components/MainLayout";
import { HandleLoading, move2Top } from "Utils/Helpers/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { get_characters } from "http/components/Requests";
import { set_CharacterData } from "../../Redux/slices/dataSlice";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import Characters from "./components/Characters";

export default function CharactersIndex() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [filters, setFilters] = useState({ price: 0, date: 0 });

  const { character, loading } = useSelector((state) => ({
    character: state.data.character,
    loading: state.setting.loading,
  }));

  useEffect(() => {
    (async () => {
      dispatch(HandleLoading(true));
      await getData();
      dispatch(HandleLoading(false));
    })();
  }, []);

  const getData = async (new_page = 1) => {
    const price = filters.price === 1 ? "i" : filters.price === 2 ? "d" : null;
    const date = filters.date === 1 ? "i" : filters.date === 2 ? "d" : null;
    const response = await get_characters(new_page, price, date);
    if (CheckApiStatus(response)) {
      if (response.data.paginattion.page === 1) {
        dispatch(
          set_CharacterData({
            data: response.data.infos,
            paginattion: response.data.paginattion,
          })
        );
      } else {
        let total_character = character.data;
        total_character = total_character.concat(response.data.infos);
        dispatch(
          set_CharacterData({
            data: total_character,
            paginattion: response.data.paginattion,
          })
        );
      }
      setPage(response.data.paginattion.page);
      setTotal(response.data.paginattion.totalPages);
    }
  };

  useEffect(() => {
    move2Top();
  }, []);

  const handleScroll = () => {
    if (window.innerWidth <= 992) {
      const md = document.getElementById("paperbody");
      if (md.scrollTop >= md.scrollHeight - md.offsetHeight - 10) {
        onChangePage();
      }
    } else {
      const mc = document.getElementById("main-content");
      if (mc.scrollTop >= mc.scrollHeight - mc.offsetHeight - 10) {
        onChangePage();
      }
    }
  };

  useEffect(() => {
    if (!loading && total !== 1) {
      if (window.innerWidth <= 992) {
        const md = document.getElementById("paperbody");
        md && md.addEventListener("scroll", handleScroll);
        return () => {
          md && md.removeEventListener("scroll", handleScroll);
        };
      } else {
        const mc = document.getElementById("main-content");
        mc && mc.addEventListener("scroll", handleScroll);
        return () => {
          mc && mc.removeEventListener("scroll", handleScroll);
        };
      }
    }
  }, [page, total, loading]);

  useEffect(() => {
    (async () => {
      dispatch(HandleLoading(true));
      await getData(1);
      dispatch(HandleLoading(false));
    })();
  }, [filters.price, filters.date]);

  const onChangePage = async () => {
    if (!loading && page !== total) {
      dispatch(HandleLoading(true));
      await getData(page + 1);
      dispatch(HandleLoading(false));
    }
  };

  const onChangeFilter = (name, value) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  return (
    <>
      <MainLayout
        flat
        pageContent={
          <Characters filters={filters} onChangeFilter={onChangeFilter} />
        }
      />
    </>
  );
}
